<template>
    <div class="row">
        <div class="col-12">
            <div class="card bg-light">
                <div class="card-body">
                    <h4>New Category</h4>
                    <!-- display alert message desktop view -->
                    <div v-if="msg !== ''" :class="`alert alert-${color} text-center my-2 p-1`" role="alert">
                        <i class="fas fa-exclamation-circle"></i> {{ msg }}
                    </div>
                    <form>
                        <div class="input-group">
                            <input v-model="categoryName" type="text" id="categoryName" required class="form-control no-lines" placeholder="Category name">
                            <div class="input-group-prepend">
                                <button @click.prevent="saveCategoryFxn" class="input-group-text btn btn-dark-green">
                                    <i class="fas fa-save fa-sm mr-1"></i> Save
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: "NewCategory", 
    data() {
        return {
            msg: '',
            color: 'danger',
            categoryName: ''
        }
    },
    methods: {
        ...mapActions(['addCategoryAction']),
        saveCategoryFxn() {
            if(this.categoryName === ''){ this.msg = "Enter a unique category name!"; return }
            let categoryObj = {
                categoryName: this.categoryName
            }
            this.addCategoryAction(categoryObj)
            .then((data) => {
                if(!data.error){ 
                    this.color = "success" 
                    this.categoryName = ""
                }
                this.msg = data.msg
            })
            .catch((e) => {
                this.color = "danger"
                this.msg = "Something went wrong while saving the category! Try again"
            })
        }
    }
}
</script>
